import * as React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/modules/auth/context/AuthContext'

export default function AppLauncher() {
  const { user, profile, loading } = useAuth()
  const navigate = useNavigate()
  const { search } = useLocation()

  React.useEffect(() => {
    if (loading) return
    const params = new URLSearchParams(search)
    const to = decideDestination({ user, role: profile?.role || null, params })
    if (to) navigate(to, { replace: true })
  }, [loading, user, profile?.role, search, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <span className="text-sm text-foreground/70">Carregando…</span>
    </div>
  )
}

function decideDestination({ user, role, params }: { user: any; role: string | null; params: URLSearchParams }) {
  const preferred = params.get('to')
  if (preferred) {
    try {
      const dec = decodeURIComponent(preferred)
      return dec.startsWith('/') ? dec : `/${dec}`
    } catch {
      return preferred
    }
  }
  if (!user) return '/login'
  switch (role) {
    case 'master':
      // Para acessos sem "to" explícito, manter comportamento atual.
      return '/dashboard-master'
    case 'afiliado':
      return '/dashboard-affiliate'
    default:
      return '/oportunidades'
  }
}
